export default "__VITE_ASSET__BWJ3qOf0__"